import Home from './components/dashboard/dashboard.vue';
import ActivateAccount from './components/dashboard/activate-account/activate-account.vue';
import Logged from './components/dashboard/my-account/my-account.vue';
import ActivationCodes from './components/dashboard/activation-codes/activation-codes.vue';
import ActivationInfo from './components/dashboard/activation-codes/activation-info.vue';
import Purchases from './components/dashboard/purchases/purchases.vue';
import Settings from './components/dashboard/settings/settings.vue';
import MyMedicalData from './components/dashboard/my-data/my-medical-data.vue';
import MyMedicalResults from './components/dashboard/medical-results/medical-results.vue';
import ResultDetailed from './components/dashboard/medical-results/result-detailed.vue';
import PasswordReminder from './components/dashboard/auth/password-reminder.vue';
import AcconutInformation from './components/dashboard/auth/account-info.vue';
import PasswordReminderFinish from './components/dashboard/auth/password-reminder-finish.vue';
import * as GoogleMaps from './components/shared/google-maps/maps.vue';
import LoginViewFromShop from './components/dashboard/auth/login-signin.vue';
import SendActivationLinkAgain from './components/dashboard/activate-account/send-activation-link-again.vue';
import BannedAccount from './components/dashboard/banned-account/banned-account.vue';
import UnlockRequestSent from './components/dashboard/banned-account/unlock-request-sent.vue';
import LoginOauth from './components/dashboard/auth/login-oauth.vue';

export const routes = [
    {
        path: '/',
        name: 'dashboard',
        redirect: { name: 'moje-konto' },
        components: {
            default: Home,
            componentsview: Logged,
        },
    },
    {
        path: '/logowanie',
        name: 'logowanie',
        component: LoginViewFromShop,
    },
    {
        path: '/oauth/:lang',
        component: LoginOauth,
    },
    {
        path: '/przypomnij-haslo',
        name: 'password-reminder',
        component: PasswordReminder,
    },

    {
        path: '/account-info',
        name: 'account-info',
        component: AcconutInformation,
    },

    {
        path: '/ustaw-haslo/:token',
        name: 'password-reminder-finish',
        component: PasswordReminderFinish,
    },
    {
        path: '/aktywacja-konta/:token*',
        name: 'aktywacja-konta',
        component: ActivateAccount,
    },
    {
        path: '/wyslij-kod-aktywacyjny',
        name: 'wyslij-kod-aktywacyjny',
        component: SendActivationLinkAgain,
    },
    {
        path: '/konto-nieaktywne',
        name: 'konto-nieaktywne',
        component: BannedAccount,
    },
    {
        path: '/prosba-wyslana',
        name: 'prosba-wyslana',
        component: UnlockRequestSent,
    },
    {
        path: '/moje-konto',
        name: 'moje-konto',
        components: {
            default: Home,
            componentsview: Logged,
        },
        meta: {
            authenticationRequired: true,
        },
    },
    {
        path: '/wyniki-badan',
        name: 'lista-wynikow',
        components: {
            default: Home,
            componentsview: MyMedicalResults,
        },
        meta: {
            authenticationRequired: true,
        },
    },
    {
        path: '/wyniki-badan/:id',
        name: 'szczegoly-badania',
        components: {
            default: Home,
            componentsview: ResultDetailed,
            map: GoogleMaps,
        },
        meta: {
            authenticationRequired: true,
        },
    },
    {
        path: '/moje-dane',
        name: 'moje-dane',
        components: {
            default: Home,
            componentsview: MyMedicalData,
        },
        meta: {
            authenticationRequired: true,
        },
    },
    {
        path: '/moje-zakupy',
        components: {
            default: Home,
            componentsview: Purchases,
        },
        meta: {
            authenticationRequired: true,
        },
    },
    {
        path: '/kody-aktywacyjne',
        components: {
            default: Home,
            componentsview: ActivationCodes,
            info: ActivationInfo,
        },
        meta: {
            authenticationRequired: true,
        },
    },
    {
        path: '/ustawienia',
        components: {
            default: Home,
            componentsview: Settings,
        },
        meta: {
            authenticationRequired: true,
        },
    },

    { path: '*', redirect: { name: 'moje-konto' } },
];



// WEBPACK FOOTER //
// ./src/routes.js